import { Component, OnInit } from '@angular/core';

import { Profile } from '../../_models/profile';

@Component({
  selector: 'app-profile-detail',
  templateUrl: './profile-detail.component.html',
  styleUrls: ['./profile-detail.component.sass'],
})
export class ProfileDetailComponent implements OnInit {
  profile: Profile;

  constructor() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/profile/profile-detail/profile-detail.component.ts